// Shared constants for PrymeBet legal & policy pages.
// Keep authoritative, verified facts here only. Do not add unverified specifics.
export const ENTITY = "PNRBET LLC DBA PRYMEBET";
export const ADDRESS = "Allison Park, PA";
export const PLATFORM = "PrymeBet.app";

// Problem-gambling helpline per source documents 02 & 07.
export const HELPLINE = "1-800-MY-RESET";
export const HELPLINE_URL = "https://www.1800myreset.org";

// "Last updated" stamp for the revisions finalized on this date. Revised policies
// become effective on their actual publication/adoption date (not backdated); the
// original Sept 12, 2026 effective date is preserved only for policies adopted then.
export const LAST_UPDATED = "October 9, 2026";

// Standard No-Purchase-Necessary banner text.
export const NPN =
  "NO PURCHASE OR PAYMENT IS NECESSARY TO ENTER OR WIN. A PURCHASE WILL NOT INCREASE YOUR CHANCES OF WINNING. VOID WHERE PROHIBITED.";
